import Icon from '../components/Icon';

const CollTopPicks = Icon(
  'coll-top-picks',
  <>
    <path d="M7 15.86.26 22.52c-.73.73.23 1.9 1.09 1.32l7.83-5.34c1.99-1.49-.34-4.31-2.18-2.65v.01Zm-5.66 1.39 6.58-4.31c2.05-1.49-.32-4.37-2.18-2.65 0 .01-5.49 5.64-5.49 5.64-.71.73.23 1.88 1.09 1.32ZM23.5 5.45l-3.72-.54a2.3 2.3 0 0 1-1.73-1.25L16.39.32a.597.597 0 0 0-1.06 0l-1.66 3.34c-.34.67-.98 1.14-1.73 1.25l-3.72.54c-.48.07-.68.66-.33 1l2.69 2.6c.54.52.79 1.28.66 2.02l-.63 3.67c-.08.48.42.84.85.62l3.32-1.73c.67-.35 1.47-.35 2.14 0l3.32 1.73c.43.23.94-.14.85-.62l-.63-3.67c-.13-.74.12-1.5.66-2.02l2.69-2.6c.35-.34.16-.93-.33-1h.02Zm-8.86 10.41L7.9 22.52c-.73.73.23 1.9 1.09 1.32l7.83-5.34c1.99-1.49-.34-4.31-2.18-2.65v.01Z" />
  </>
);

export default CollTopPicks;
